import { styled } from '@/shared/ui';

import { TCardItem } from './types';

export const StyledCardItem = styled('div')<TCardItem>`
  min-width: 330px;
  width: 100%;
  border-radius: 5px;
  border: ${({ selected, theme }) =>
    `1px solid ${selected ? theme.palette.custom.violet : theme.palette.custom.grey9}`};
  background-color: ${({ selected, theme }) =>
    selected ? theme.palette.secondary.main : theme.palette.common.white};
  color: ${({ selected, theme }) =>
    `${selected ? theme.palette.common.white : 'inherit'}`};
  cursor: pointer;
  box-shadow: ${({ selected, theme }) =>
    selected ? `0 9px 12px -6px ${theme.palette.custom.black[20]}` : 'none'};
`;
